import { useLocale } from "@/context/LocaleContext";
import { Globe } from "lucide-react";

export default function LocaleSwitcher({ variant = "default" }) {
  const { locale, toggle } = useLocale();
  const label = locale === "id" ? "EN" : "ID";
  const className = variant === "footer"
    ? "inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 text-white px-3 py-1.5 text-xs font-semibold hover:bg-white/20 transition"
    : "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold text-slate-700 hover:text-[var(--brand-blue)] hover:bg-slate-100 transition";
  return (
    <button
      onClick={toggle}
      className={className}
      aria-label="Ganti bahasa"
      data-testid="locale-switcher"
    >
      <Globe className="h-3.5 w-3.5" /> {label}
    </button>
  );
}
